// extracted by mini-css-extract-plugin
module.exports = {"planUpgradeBtn":"unavailableBtnPlan_planUpgradeBtn__3VJ-o","smallBtn":"unavailableBtnPlan_smallBtn__2q7nh"};